import { createUseStyles } from 'react-jss'

import { container } from '../../../../styles/common'
import { zIndex9 } from '../../../../styles/const/common'

export const headerHeight = 50

const useStyles = createUseStyles({
  header: {
    width: '100%',
    padding: '0 20px',
    backgroundColor: 'white',
    boxShadow: '0 1px 5px 2px rgba(0,0,0,.05)',
    minHeight: headerHeight,
    zIndex: zIndex9,
    position: 'relative'
  },
  container: {
    extend: container,
    maxWidth: 1500,
    display: 'flex',
    alignItems: 'center',
    minHeight: headerHeight,
    maxHeight: 72,
    justifyContent: 'center'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 0,
    maxHeight: '100%',
    textDecoration: 'none',
    '& svg': {
      width: '100%',
      maxWidth: 120,
      height: 'auto'
    }
  },
  logoutBtn: {
    position: 'absolute',
    right: 20,
    top: '50%',
    transform: 'translateY(-50%)',
    margin: 0
  }
})

export default useStyles
